import { render } from "./Inputs.vue?vue&type=template&id=d1989a74"
import script from "./Inputs.vue?vue&type=script&lang=js"
export * from "./Inputs.vue?vue&type=script&lang=js"

import exportComponent from "/app/tmp/blackhall/V3/v2026.19.r0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__